{
  "title": "如何讓隊伍晉級下一輪",
  "description": "從初賽的作品中選出隊伍，批次晉級進入決賽輪次。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，被選中的隊伍會出現在決賽輪次中，該隊隊員也會收到晉級通知信。",
  "roleNote": "主辦方管理員",
  "prerequisites": ["競賽已建立初賽與決賽兩個輪次", "初賽已完成評分並確定要晉級的名單"],
  "pathLabel": "主辦方主控台 → 決賽輪次 → 晉級名單",
  "steps": [
    {
      "title": "1. 決定晉級名單",
      "description": "依初賽評分結果或其他考量，決定哪些初賽作品所屬的隊伍要晉級決賽。"
    },
    {
      "title": "2. 選取初賽作品並送出",
      "description": "在決賽輪次的晉級功能中，勾選對應的初賽作品（以作品為單位選取，系統會自動對應到該作品所屬的隊伍），可附加備註後送出。"
    },
    {
      "title": "3. 確認結果",
      "description": "送出後，每個作品會建立一筆晉級紀錄；若某隊伍已經晉級過這個輪次，會自動略過、不會重複建立，因此可放心分批次或補選後重新送出同一份清單。"
    }
  ],
  "afterward": [
    "晉級的隊伍出現在決賽輪次的名單中，可以開始在決賽輪次建立與繳交新的作品",
    "該隊除指導老師外的每位成員都會收到一封晉級通知信；確認畫面會事先說明系統將以 Email 通知入圍隊伍的隊員，寄送成功與失敗的人數會記錄在稽核紀錄",
    "已晉級的隊伍再次被選取不會出錯或建立重複紀錄"
  ],
  "nextSteps": "隊伍晉級後，請確認決賽輪次的時程、投稿表與評分規準皆已設定完成，讓晉級隊伍能順利參加決賽。",
  "faq": [
    {
      "q": "同一份晉級名單可以分批次選取、重複送出嗎？",
      "a": "可以。系統會針對每個作品檢查其所屬隊伍是否已晉級到這個輪次，已晉級的會直接略過不重複建立，所以可以先選一批送出，之後再選漏掉的補送，不需要一次選齊。"
    },
    {
      "q": "晉級是以作品為單位還是以隊伍為單位？",
      "a": "操作介面上是勾選初賽的「作品」，但實際建立的晉級紀錄是綁定到該作品所屬的「隊伍」；同一隊伍在初賽即使有多件作品，只要其中一件被勾選晉級，該隊伍就算晉級。"
    },
    {
      "q": "晉級通知信會寄給隊伍裡的所有人嗎？",
      "a": "會寄給隊伍中除了「指導老師」角色以外的每一位成員。"
    }
  ]
}
